import { render, staticRenderFns } from "./ItemTopControls.vue?vue&type=template&id=496a6274&lang=pug&"
import script from "./ItemTopControls.vue?vue&type=script&lang=ts&"
export * from "./ItemTopControls.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports